// Человеческое название действия из журнала аудита по методу и пути запроса.
// Возвращает ключ перевода audit.actions.* или null (тогда показывается тип запроса).
const RULES = [
  ['POST', /^\/tenants$/, 'companyCreated'],
  ['PUT', /^\/tenants\/\d+$/, 'companyUpdated'],
  ['DELETE', /^\/tenants\/\d+$/, 'companyDeleted'],
  ['PUT', /^\/tenants\/\d+\/config$/, 'brandingUpdated'],
  ['POST', /^\/tenants\/\d+\/admins$/, 'memberAdded'],
  ['PATCH', /^\/tenants\/\d+\/admins\/\d+$/, 'memberUpdated'],
  ['DELETE', /^\/tenants\/\d+\/admins\/\d+$/, 'memberRemoved'],
  ['POST', /^\/tenants\/\d+\/payments$/, 'paymentAdded'],
  ['DELETE', /^\/tenants\/\d+\/payments\/\d+$/, 'paymentDeleted'],
  ['POST', /^\/tenants\/\d+\/documents$/, 'documentUploaded'],
  ['DELETE', /^\/tenants\/\d+\/documents\/\d+$/, 'documentDeleted'],
  ['POST', /^\/tenants\/\d+\/servio-check$/, 'posChecked'],
  ['PUT', /^\/user\/\d+\/profile$/, 'employeeProfile'],
  ['POST', /^\/user\/\d+\/set-credentials$/, 'employeePassword'],
  ['DELETE', /^\/user\/\d+$/, 'employeeDeleted'],
  ['POST', /^\/update-e-wallet\/\d+$/, 'employeeSynced'],
  ['POST', /^\/update-all-e-wallets$/, 'massSync'],
  ['POST', /^\/send-push-manual$/, 'pushSent'],
  ['POST', /^\/push\/to-phone$/, 'pushSent'],
  ['DELETE', /^\/push\/notification\/\d+$/, 'pushDeleted'],
  ['POST', /^\/push-rules$/, 'pushRuleCreated'],
  ['PUT', /^\/push-rules\/\d+$/, 'pushRuleUpdated'],
  ['DELETE', /^\/push-rule\/\d+$/, 'pushRuleDeleted'],
  ['POST', /^\/restaurants$/, 'restaurantSaved'],
  ['DELETE', /^\/restaurants\/\d+$/, 'restaurantDeleted'],
  ['POST', /^\/security\/ban-ip$/, 'ipBanned'],
  ['DELETE', /^\/security\/unban-ip\/\d+$/, 'ipUnbanned'],
  ['POST', /^\/security\/whitelist-ip$/, 'ipWhitelisted'],
  ['DELETE', /^\/security\/whitelist-ip\/.+$/, 'ipUnwhitelisted'],
  ['POST', /^\/database\/query$/, 'sqlExecuted'],
  ['POST', /^\/backup$/, 'backupCreated'],
  ['POST', /^\/cron-settings$/, 'cronChanged'],
  ['POST', /^\/settings\/theme$/, 'themeChanged'],
  ['POST', /^\/upload$/, 'fileUploaded'],
];

export function auditActionKey(method, path) {
  const short = String(path || '').replace(/^\/api\/admin/, '');
  const rule = RULES.find(([m, re]) => m === method && re.test(short));
  return rule ? `audit.actions.${rule[2]}` : null;
}

export const shortAuditPath = (path) => String(path || '').replace(/^\/api\/admin/, '');
